import Vue from 'vue'
import '../../plugins/axios'
import '../../plugins/machine'
import App from './App.vue'
import i18n from '@/plugins/i18n'
import Base64 from 'crypto-js/enc-base64'
import CryptoJS from 'crypto-js'
import Logger from '@/plugins/logger'
import '@/plugins/polyfill-object-fromentries'
import useLanguageTree from '@/commons/language'
import useIEHelper from '@/commons/ie-helper'
import loadWhitelabel, { buildWLParam } from '@/commons/whitelabel.js'
import { loadRecaptchaConfig } from '@/commons/recaptcha-config.js'
import { performBrowserExchangeRedirect } from '@/commons/oauth'
import VueCompositionAPI from '@vue/composition-api'

Vue.use(VueCompositionAPI)
const { URLSearchParamsWrapper } = useIEHelper()
const { t } = useLanguageTree()

Vue.prototype.$tf = t
Vue.use(Logger, { level: 8 })

Vue.config.productionTip = false

let urlParams = URLSearchParamsWrapper(window.location.search)
const wl = decodeURIComponent(urlParams.get('wl') || '')
Vue.prototype.$wlDomain = wl

let hl = urlParams.get('hl') || i18n.locale || 'en-US'

let methods = urlParams.get('access_methods')
Vue.prototype.$oidcRegistrationMode = urlParams.get('oidc_registration_mode') || ''

if (methods) {
  methods = methods.replace(/\./g, '+').replace(/_/g, '/').replace(/-/g, '=')
  methods = JSON.parse(Base64.parse(methods).toString(CryptoJS.enc.Utf8)) || null
  if (methods && methods.length === 1 && methods[0].oauth2_access_method && methods[0].oauth2_access_method.url) {
    if (!methods[0].oauth2_access_method.requires_browser_exchange) {
      window.location.href = methods[0].oauth2_access_method.url
    } else {
      performBrowserExchangeRedirect(methods[0].oauth2_access_method, wl, hl)
    }
  } else {
    Vue.prototype.$methods = methods
    Promise.all([
      loadRecaptchaConfig(),
      loadWhitelabel(Vue.prototype.$wlDomain)
    ]).then(([config, res]) => {
      Vue.prototype.$recaptchaKey = config.recaptchaKey
      Vue.prototype.$recaptchaEnterprise = config.recaptchaEnterprise
      Vue.prototype.$allowSelfRegistration = config.allowSelfRegistration
      const vuetify = res.vuetify
      Vue.prototype.$headerLogo = res.headerLogo
      Vue.prototype.$wlURL = res.whitelabelURL
      Vue.prototype.$serverConfig = res.serverConfig
      Vue.use(vuetify)
      const app = new Vue({
        i18n,
        vuetify,
        render: h => h(App)
      }).$mount('#app')

      if (process.env.NODE_ENV === 'development' && window) {
        window.app = app
        window.Vue = Vue
      }
    })
  }
} else {
  window.axios.post('access-methods' + buildWLParam(wl, '?')).then(response => {
    if (response.data.length === 1 && response.data[0].url) {
      window.location.href = response.data[0].url
    } else {
      Vue.prototype.$methods = response.data
      Promise.all([
        loadRecaptchaConfig(),
        loadWhitelabel(Vue.prototype.$wlDomain)
      ]).then(([config, res]) => {
        Vue.prototype.$recaptchaKey = config.recaptchaKey
        Vue.prototype.$recaptchaEnterprise = config.recaptchaEnterprise
        Vue.prototype.$allowSelfRegistration = config.allowSelfRegistration
        const vuetify = res.vuetify
        Vue.prototype.$headerLogo = res.headerLogo
        Vue.prototype.$wlURL = res.whitelabelURL
        Vue.use(vuetify)
        const app = new Vue({
          i18n,
          vuetify,
          render: h => h(App)
        }).$mount('#app')

        if (process.env.NODE_ENV === 'development' && window) {
          window.app = app
          window.Vue = Vue
        }
      })
    }
  }).catch(() => {
    if (window.location.pathname === '/register') {
      window.location.href = '/error?hl=' + hl + '&error_message=accessMethodError' + buildWLParam(wl)
    } else {
      Promise.all([
        loadRecaptchaConfig(),
        loadWhitelabel(Vue.prototype.$wlDomain)
      ]).then(([config, res]) => {
        Vue.prototype.$recaptchaKey = config.recaptchaKey
        Vue.prototype.$recaptchaEnterprise = config.recaptchaEnterprise
        Vue.prototype.$allowSelfRegistration = config.allowSelfRegistration
        const vuetify = res.vuetify
        Vue.prototype.$headerLogo = res.headerLogo
        Vue.prototype.$wlURL = res.whitelabelURL
        Vue.use(vuetify)
        const app = new Vue({
          i18n,
          vuetify,
          render: h => h(App)
        }).$mount('#app')

        if (process.env.NODE_ENV === 'development' && window) {
          window.app = app
          window.Vue = Vue
        }
      })
    }
  })
}
